import {
  IAnnouncementsModel,
  IAnnouncementsResponse,
} from './announcements.model';

export const getAnnouncements = (
  state: IAnnouncementsModel
): IAnnouncementsResponse[] => state.data;
